import React, { Component } from 'react';
import CountOnline from './CountOnline';
import Chat from './Chat';
import Slido from './Slido';
import Banner from './Banner';
import Copyright from '../common/Copyright';
import Cookie from "../common/Cookie";
import CenteredLoader from '../common/CenteredLoader';
import EventParams from "./EventParams";
import { Typography, Box, Button } from '@mui/material';
import Parameters from '../common/Parameters';
import screenfull from 'screenfull';
import './css/main.css';
import Translation from "../common/Translation";

const BANNER_HEIGHT_PX = 60;

class Webinar extends Component {
    constructor(props) {
        super(props);
        this.params = new URLSearchParams(window.location.search);

        const initialState = EventParams.paramNames().reduce((obj, item) => {
            return {
                ...obj,
                [item]: '',
            };
        }, {error: ''});

        this.state = {
            ...initialState,
            id: '',
            eventId: 0,
            sendBtnText: ''
        };

        this.player = null;
        this.openFullScreen=this.openFullScreen.bind(this);
    }


    static get getSendButtonText() {
        return 'Отправить';
    }

    getBoxcastVideoUrl(boxcast_video_id) {
        let url = `https://boxcast.tv/view-embed/${boxcast_video_id}?showTitle=0&showDescription=0&showHighlights=0&showRelated=0&showCountdown=1&market=smb&showDocuments=0&showIndex=0&showDonations=0`;
        return this.state.google_video_params.trim().length > 0
            ? url + '&' + this.state.google_video_params
            : url;
        // <iframe width="720" height="800"
        //         src="https://boxcast.tv/view-embed/landlord-ua-zbrptcok0fafukrzdlu1?showTitle=0&showDescription=0&showHighlights=0&showRelated=0&showCountdown=1&market=smb&showDocuments=0&showIndex=0&showDonations=0"
        //         frameBorder="0" scrolling="auto" allowFullScreen="true" allow="autoplay; fullscreen"></iframe>
    }

    getGoogleVideoUrl(google_video_id) {
        // <iframe width="_BADGEWIDTH_" height="_BADGEHEIGHT_" src="https://www.youtube.com/embed/_GOOGLEVIDEOID_?rel=0&vq=hd720&showinfo=0&autoplay=1&playsinline=1&modestbranding=1_GOOGLEVIDEOPARAMS_" allow="autoplay; encrypted-media" frameborder="0"></iframe>
        return `https://www.youtube.com/embed/${google_video_id}?rel=0&showinfo=0&autoplay=1&playsinline=1&modestbranding=1&${this.state.google_video_params}`;
    }

    getVimeoUrl(vimeo_video_id) {
        return `https://player.vimeo.com/video/${vimeo_video_id}`;
    }

    getVideoPlayer() {
        if(this.state.video_provider === 'google') {
            return (
                <iframe width={'100%'}
                        height={'100%'}
                        src={this.getGoogleVideoUrl(this.state.google_video_id)}
                        style={{ border: 0 }}
                        allowFullScreen
                        allow={"autoplay; fullscreen; encrypted-media"}/>
            )
        }

        if(this.state.video_provider === 'boxcast') {
            return (
                <iframe width={'100%'} height={'100%'}
                        src={this.getBoxcastVideoUrl(this.state.google_video_id)}
                        style={{ border: 0 }}
                        allowFullScreen
                        allow={"autoplay; fullscreen"}/>
            )
        }

        if(this.state.video_provider === 'vimeo') {
            return (<iframe src={this.getVimeoUrl(this.state.google_video_id)}
                            allow="autoplay; fullscreen; picture-in-picture" allowFullScreen
                            style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border: 0}}/>);
        }

        return null;
    }

    adjustSidebarHeights() {
        setTimeout(() => {
            const sidebar = document.getElementById('sidebar-container');
            const slido = document.getElementById('slido-container');
            const chat = document.getElementById('chat-container');
            const videoContainer = document.getElementById('video-frame-container');

            if (!sidebar || !videoContainer) {
                console.log(`Sidebar heights not found, retrying in 1s |${!sidebar} | ${!videoContainer}|`);
                setTimeout(this.adjustSidebarHeights, 1000);
                return;
            }

            if (window.innerWidth < 900) {
                return; // mobile: CSS handles layout, page scrolls
            }

            const totalHeight = videoContainer.offsetHeight;
            const activeSections = [slido, chat].filter(Boolean);
            if (activeSections.length === 0) {
                return;
            }

            const sectionHeight = Math.max(Math.floor(totalHeight / activeSections.length), 0);

            if (slido) {
                slido.style.height = `${sectionHeight}px`;
                slido.style.overflow = 'auto';
            }

            if (chat) {
                chat.style.height = `${sectionHeight}px`;
                chat.style.overflow = 'auto';
                chat.scrollTop = chat.scrollHeight;
            }

        }, 1500);
    }


    setDefaultMessage() {
      this.setState({
        sendBtnText: Webinar.getSendButtonText
      });
    }

    static get getMemberNotFoundMessage() {
        return 'Участника не найдено';
    }

    normalizeHexColor(color) {
        if (!color || typeof color !== 'string') {
            return null;
        }

        const value = color.trim();
        if (!value.startsWith('#')) {
            return null;
        }

        if (value.length === 4) {
            return `#${value[1]}${value[1]}${value[2]}${value[2]}${value[3]}${value[3]}`;
        }

        return value.length === 7 ? value : null;
    }

    isLightColor(color) {
        const normalized = this.normalizeHexColor(color);
        if (!normalized) {
            return false;
        }

        const r = parseInt(normalized.slice(1, 3), 16);
        const g = parseInt(normalized.slice(3, 5), 16);
        const b = parseInt(normalized.slice(5, 7), 16);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;

        return brightness >= 186;
    }

    getHeaderControlTheme() {
        const roomColor = this.state.room_font_color || '#000000';
        const useDarkText = this.isLightColor(roomColor);

        return {
            textColor: useDarkText ? '#1f2937' : '#ffffff',
            borderColor: useDarkText ? 'rgba(31, 41, 55, 0.24)' : 'rgba(255, 255, 255, 0.55)',
            backgroundColor: useDarkText ? 'rgba(255, 255, 255, 0.9)' : 'rgba(17, 24, 39, 0.58)',
            hoverBackgroundColor: useDarkText ? 'rgba(255, 255, 255, 0.98)' : 'rgba(17, 24, 39, 0.72)',
        };
    }

    componentDidMount() {
        let lang = this.params.get('lang');
        lang = !!lang ? lang : Cookie.get(Cookie.LANG);
        let id = this.params.get('id');

        if (!id) {
            Translation.translate([Webinar.getMemberNotFoundMessage], lang, (translation) => {
                this.setState({error: translation[Webinar.getMemberNotFoundMessage]});
            }, () => {
                this.setState({error: Webinar.getMemberNotFoundMessage});
            });
            return;
        }

        // id - user registration code
        EventParams.get(id, lang, (event) => {
            EventParams.paramNames().forEach((name) => {
                let state = this.state;
                state[name] = event.hasOwnProperty(name)
                    ? event[name]
                    : '';

                this.setState({
                    ...state,
                    id: id
                });
            });

            Translation.translate([Webinar.getSendButtonText], lang, (translation) => {
                    this.setState({
                        sendBtnText: translation[Webinar.getSendButtonText],
                    });
                }, () => {
                    this.setDefaultMessage();
                }
            );

        }, (error) => {
            this.setState({error: typeof error === 'string' ? error : Webinar.getMemberNotFoundMessage})
        });

        const eventId = this.params.get('event_id');
        if (eventId) {
            Cookie.set('event_id', eventId, 7);
        }

        this.adjustSidebarHeights();
        window.addEventListener('resize', this.adjustSidebarHeights);
    }

    // Define stream name by name of video_id
    detectStreamName(streamAttr) {
        let streams = Object.entries(this.state.streams);
        for (let s of streams) {
            if(s.length > 1
                && (s[0].trim() === streamAttr
                    || s[1].trim() === streamAttr)) {
                return s[0].trim();
            }
        }
        return streamAttr;
    }

    getQuizByStream(streamId) {

        let stream = this.detectStreamName(streamId);
        let quizList=this.state.quiz_id.split(',');
        let defaultQuizId = null;
        for (let quiz of quizList) {
            quiz = quiz.trim();
            let delimPos = quiz.indexOf(':');
            let url = quiz.substring(delimPos+1);
            let quizName = quiz.substring(0, delimPos)

            if(quizName === stream) {
                return url.trim();
            }

            defaultQuizId = !!defaultQuizId
                ? defaultQuizId
                : url.trim();
        }

        return !!defaultQuizId ? defaultQuizId : this.state.quiz_id;
    }

    switchStream(streamId) {
        if(streamId.substr(0,4).toLowerCase() === 'http') {
            let a = document.createElement('A');
            a.href = streamId;
            a.download = streamId.substr(streamId.lastIndexOf('/') + 1);
            a.target = '_blank';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            return;
        }

        this.setState({
            ...this.state,
            google_video_id: streamId
        });
    }

    createStreamButtons() {
        if(!this.state.streams) {
            return null;
        }

        let arr = Object.entries(this.state.streams);
        if(arr.length < 2) {
            return null;
        }

        const headerControlTheme = this.getHeaderControlTheme();

        return arr.map((elem) => {
            return (
                <Button
                    key={"btn-"+elem[0]}
                    variant="outlined"
                    color="primary"
                    onClick={() => { this.switchStream(elem[1])}}
                    sx={{
                        color: headerControlTheme.textColor,
                        borderColor: headerControlTheme.borderColor,
                        backgroundColor: headerControlTheme.backgroundColor,
                        backdropFilter: 'blur(6px)',
                        '&:hover': {
                            borderColor: headerControlTheme.borderColor,
                            backgroundColor: headerControlTheme.hoverBackgroundColor,
                        },
                    }}
                >
                    <Typography sx={{ color: 'inherit' }}>{elem[0]}</Typography>
                </Button>
            );
        });
    }

    openFullScreen() {
        screenfull.request(findDOMNode(this.player))
    }


    render() {
        if (this.state.error !== '') {
            let error = typeof this.state.error === 'string' ? this.state.error : 'Unexpected error';
            return (
                <Typography variant="h4" component="h4" gutterBottom>
                    {error}
                </Typography>
            );
        }

        if (this.state.is_after_event_quiz > 0) {
            const parameters = new Parameters();
            window.location.href = "/index.html?p=quiz&id=" + parameters.getMemberId() + "&event_id=" + parameters.getEventId();
            return null;
        }

        if (this.state.google_video_id === '') {
            return <CenteredLoader />;
        }

        const streamButtons = this.state.streams ? this.createStreamButtons() : null;
        const isBackgroundPresent = typeof this.state.background_file !== 'undefined' && this.state.background_file.length > 8;
        const backgroundImage = isBackgroundPresent
            ? `url(${this.state.background_file})`
            : 'url(/images/0.jpg)';
        const hasBanner = !!this.state.banner_file;
        const showChat = Number(this.state.is_chat_enabled) === 1;
        const showSlido = Number(this.state.is_quiz_enabled) === 1;
        const showSidebar = showChat || showSlido;
        const headerControlTheme = this.getHeaderControlTheme();

        return (
            <Box
                sx={{
                    margin: 0,
                    padding: 0,
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh',
                    maxHeight: '100vh',
                    backgroundImage: backgroundImage,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    color: this.state.room_font_color || '#000000',
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    boxSizing: 'border-box',
                    position: 'relative',
                }}
            >
                <Box
                    sx={{
                        flexShrink: 0,
                        height: hasBanner ? `calc(100vh - ${BANNER_HEIGHT_PX}px)` : '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        minHeight: 0,
                        width: '100%',
                    }}
                >
                {/* Row 1: Header with event name, stream buttons, and count online */}
                <Box
                    id="header-container"
                    sx={{
                        display: 'flex',
                        flexWrap: { xs: 'wrap', md: 'nowrap' },
                        width: '100%',
                        padding: '8px',
                        boxSizing: 'border-box',
                        alignItems: 'center',
                        flexShrink: 0,
                        overflow: 'hidden',
                    }}
                >
                    <Box sx={{
                        flex: { xs: streamButtons ? '0 0 100%' : '1 1 auto', md: '1 1 auto' },
                        minWidth: 0,
                        textAlign: 'center',
                    }}>
                        <Typography id="webinar-title" variant="h6" component="h6">
                            {this.state.event_name}
                        </Typography>
                    </Box>

                    {streamButtons && (
                        <Box
                            sx={{
                                flex: '0 0 auto',
                                display: 'flex',
                                gap: '8px',
                                margin: '0 16px'
                            }}
                        >
                            {streamButtons}
                        </Box>
                    )}

                    <Box
                        sx={{
                            flex: '0 0 auto',
                            textAlign: 'right',
                            color: headerControlTheme.textColor,
                            backgroundColor: headerControlTheme.backgroundColor,
                            border: `1px solid ${headerControlTheme.borderColor}`,
                            borderRadius: '8px',
                            px: 1.5,
                            py: 0.75,
                            backdropFilter: 'blur(6px)',
                        }}
                    >
                        <CountOnline counterUrl={this.state.counterUrl} eventId={this.state.event_id} />
                    </Box>
                </Box>

                {/* Row 2: Content with video and sidebar */}
                <Box
                    id="video-frame-container"
                    sx={{
                        display: 'flex',
                        flex: '1 1 auto',
                        flexDirection: { xs: 'column', md: 'row' },
                        width: '100%',
                        minHeight: 0,
                        overflowX: 'hidden',
                        overflowY: { xs: 'auto', md: 'hidden' },
                        boxSizing: 'border-box',
                        gap: { md: '8px' },
                        minWidth: 0,
                    }}
                >
                    {/* Video container */}
                    <Box
                        id="video-frame"
                        sx={{
                            flex: {
                                xs: showSidebar ? '0 0 auto' : '1 1 auto',
                                md: showSidebar ? '3 1 0' : '1 1 0',
                            },
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            alignSelf: 'stretch',
                            width: '100%',
                            minHeight: 0,
                            minWidth: 0,
                            overflow: 'hidden',
                            boxSizing: 'border-box'
                        }}
                    >
                        <Box
                            sx={{
                                position: 'relative',
                                width: '100%',
                                maxWidth: '100%',
                                aspectRatio: '16/9',
                                maxHeight: {
                                    xs: 'none',
                                    md: '100%'
                                },
                                margin: '0 auto',
                                overflow: 'hidden',
                            }}
                        >
                            {this.getVideoPlayer()}
                        </Box>
                    </Box>

                    {/* Sidebar */}
                    {showSidebar && (
                        <Box
                            id = "sidebar-container"
                            sx={{
                                flex: { xs: '0 0 auto', md: '1 1 auto' },
                                display: 'flex',
                                flexDirection: 'column',
                                height: { xs: 'auto', md: '100%' },
                                minHeight: 0,
                                minWidth: 0,
                                overflow: { xs: 'visible', md: 'hidden' },
                            }}
                        >
                            {showSlido && (
                                <Box
                                    id="slido-container"
                                    sx={{
                                        marginBottom: showChat ? '8px' : 0,
                                        flex: { xs: '0 0 auto', md: '1 1 0' },
                                        height: { xs: '500px', md: 'auto' },
                                        minHeight: { xs: '500px', md: 0 },
                                        overflow: { xs: 'visible', md: 'auto' },
                                    }}
                                >
                                    <Slido
                                        quizId={this.getQuizByStream(this.state.google_video_id)}
                                        isEnabled="1"
                                    />
                                </Box>
                            )}

                            {showChat && (
                                <Box
                                    id="chat-container"
                                    sx={{
                                        flex: { xs: '0 0 auto', md: '1 1 0' },
                                        minHeight: { xs: '550px', md: 0 },
                                        overflow: { xs: 'visible', md: 'auto' },
                                    }}
                                >
                                    <Chat isEnabled="1" sendBtnText={this.state.sendBtnText} />
                                </Box>
                            )}
                        </Box>
                    )}
                </Box>

                </Box>

                {/* Row 3: Banner (optional) — natural full-width display, scrolls into view */}
                {hasBanner && (
                    <Box
                        sx={{
                            width: '100%',
                            boxSizing: 'border-box',
                            flexShrink: 0,
                        }}
                    >
                        <Banner src={this.state.banner_file} alt={this.state.event_name} />
                    </Box>
                )}

                {/* Row 4: Footer — flows after banner, visible via scroll */}
                <Box
                    id="copyright-container"
                    sx={{
                        width: '100%',
                        padding: '8px',
                        boxSizing: 'border-box',
                        textAlign: 'right',
                        flexShrink: 0,
                    }}
                >
                    <Copyright />
                </Box>
            </Box>
        );
    }


    // render_OLD() {
    //     // Error handling
    //     if (this.state.error !== '') {
    //         let error = typeof this.state.error === 'string' ? this.state.error : 'Unexpected error';
    //         return (
    //             <Typography variant="h4" component="h4" gutterBottom>
    //                 {error}
    //             </Typography>
    //         );
    //     }
    //
    //     if (this.state.is_after_event_quiz > 0) {
    //         const parameters = new Parameters();
    //         window.location.href = "/index.html?p=quiz&id=" + parameters.getMemberId() + "&event_id=" + parameters.getEventId();
    //         return null;
    //     }
    //
    //     if (this.state.google_video_id === '') {
    //         return (
    //             <CenteredLoader />
    //         );
    //     }
    //
    //     const streamButtons = this.state.streams ? this.createStreamButtons() : null;
    //     const isBackgroundPresent = typeof this.state.background_file !== 'undefined' && this.state.background_file.length > 8;
    //     const backgroundImage = isBackgroundPresent
    //         ? `url(${this.state.background_file})`
    //         : 'url(/images/0.jpg)';
    //     const hasBanner = !!this.state.banner_file;
    //     const showChat = this.state.is_chat_enabled === '1';
    //     const showSlido = this.state.is_quiz_enabled === '1';
    //     const showSidebar = showChat || showSlido;
    //
    //     return (
    //         <div style={{
    //             margin: 0,
    //             padding: 0,
    //             height: '100%',
    //             display: 'flex',
    //             flexDirection: 'column',
    //             minHeight: '80vh',
    //             maxHeight: '100vh',
    //             backgroundImage: backgroundImage,
    //             backgroundSize: 'cover',
    //             backgroundPosition: 'center',
    //             color: this.state.room_font_color || '#000000',
    //         }}>
    //             {/* Row 1: Header with event name, stream buttons, and count online */}
    //             <div style={{
    //                 display: 'flex',
    //                 width: '100%',
    //                 padding: '8px',
    //                 boxSizing: 'border-box',
    //                 alignItems: 'center',
    //                 flexShrink: 0,
    //             }}>
    //                 <div style={{ flex: '1 1 auto' }}>
    //                     <Typography id="webinar-title" variant="h6" component="h6">
    //                         {this.state.event_name}
    //                     </Typography>
    //                 </div>
    //
    //                 {streamButtons && (
    //                     <div style={{
    //                         flex: '0 0 auto',
    //                         display: 'flex',
    //                         gap: '8px',
    //                         margin: '0 16px'
    //                     }}>
    //                         {streamButtons}
    //                     </div>
    //                 )}
    //
    //                 <div style={{ flex: '0 0 auto', textAlign: 'right' }}>
    //                     <CountOnline counterUrl={this.state.counterUrl} eventId={this.state.event_id} />
    //                 </div>
    //             </div>
    //
    //             {/* Row 2: Content with video and sidebar */}
    //             <div style={{
    //                 display: 'flex',
    //                 width: '100%',
    //                 flex: 1,
    //                 boxSizing: 'border-box',
    //             }}>
    //                 {/* Video container */}
    //                 <div
    //                     id="video-frame"
    //                     style={{
    //                         flex: showSidebar ? '3 0 0' : '1 0 0',
    //                         position: 'relative',
    //                         boxSizing: 'border-box'
    //                     }}
    //                 >
    //                     <div style={{
    //                         position: 'absolute',
    //                         top: 0,
    //                         left: 0,
    //                         width: '100%',
    //                         height: '100%',
    //                     }}>
    //                         {this.getVideoPlayer()}
    //                     </div>
    //                 </div>
    //
    //                 {/* Sidebar */}
    //                 {showSidebar && (
    //                     <div style={{
    //                         flex: '1 0 0',
    //                         display: 'flex',
    //                         flexDirection: 'column',
    //                     }}>
    //                         {showSlido && (
    //                             <div style={{
    //                                 flex: showChat ? 1 : 2,
    //                                 marginBottom: showChat ? '8px' : 0,
    //                             }}>
    //                                 <Slido
    //                                     quizId={this.getQuizByStream(this.state.google_video_id)}
    //                                     isEnabled="1"
    //                                 />
    //                             </div>
    //                         )}
    //
    //                         {showChat && (
    //                             <div style={{
    //                                 flex: showSlido ? 1 : 2,
    //                             }}>
    //                                 <Chat isEnabled="1" sendBtnText={this.state.sendBtnText} />
    //                             </div>
    //                         )}
    //                     </div>
    //                 )}
    //             </div>
    //
    //             {/* Row 3: Banner (optional) */}
    //             {hasBanner && (
    //                 <div style={{
    //                     width: '100%',
    //                     boxSizing: 'border-box',
    //                 }}>
    //                     <Banner src={this.state.banner_file} alt={this.state.event_name} />
    //                 </div>
    //             )}
    //
    //             {/* Row 4: Footer */}
    //             <div style={{
    //                 width: '100%',
    //                 padding: '8px',
    //                 boxSizing: 'border-box',
    //                 textAlign: 'right',
    //                 flexShrink: 0,
    //             }}>
    //                 <Copyright />
    //             </div>
    //         </div>
    //     );
    // }
}

export default Webinar;
